import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchCarsByBrand } from "../services/car";
import ShortlistButton from "../components/ShortlistButton";
import "../styles/BrandPage.css";

const BrandPage = () => {
  const { brand } = useParams();
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalCars, setTotalCars] = useState(0);

  useEffect(() => {
    const loadBrandCars = async () => {
      try {
        setLoading(true);
        const formattedBrand = brand.replace(/-/g, ' ');
        const response = await fetchCarsByBrand(formattedBrand);
        setCars(response.data || []);
        setTotalCars(response.total || 0);
      } catch (error) {
        console.error("Error loading brand cars:", error);
        setCars([]);
        setTotalCars(0);
      } finally {
        setLoading(false);
      }
    };

    loadBrandCars();
  }, [brand]);

  // Format brand name for display
  const displayBrandName = brand.split('-').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ');

  if (loading) {
    return (
      <div className="brand-page">
        <div className="loading-container">
          <div className="spinner-large"></div>
          <h2>Loading {displayBrandName} Cars...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="brand-page">
      {/* HERO SECTION WITH BRAND NAME */}
      <div className="simple-hero">
        <div className="simple-hero-content">
          <h1 className="simple-hero-title">
            <span className="available-text">Available</span>
            <span className="cars-text-white">{displayBrandName} Cars</span>
          </h1>
          <p className="simple-hero-subtitle">
            {totalCars} {totalCars === 1 ? "car" : "cars"} available
          </p>
        </div>
      </div>

      {/* Cars Grid */}
      {cars.length === 0 ? (
        <div className="no-cars-message">
          <h2>No {displayBrandName} Cars Available</h2>
          <p>We currently don't have any {displayBrandName} cars in stock.</p>
          <p>Check back soon or explore other brands!</p>
          <Link to="/buy-cars" className="reset-filters-btn">
            Browse All Cars
          </Link>
        </div>
      ) : (
        <div className="models-grid-container">
          {cars.map((car) => (
            <div key={car.id} className="model-grid-card-wrapper">
              <Link to={`/car/${car.id}`} className="model-grid-card">
                <div className="model-card-image">
                  {/* Shortlist Heart Button */}
                  <div className="brand-heart-btn">
                    <ShortlistButton carId={car.id} size="medium" />
                  </div>

                  {car.images_urls && car.images_urls.length > 0 ? (
                    <img 
                      src={`http://localhost:3001${car.images_urls[0]}`}
                      alt={`${car.brand} ${car.model}`}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/placeholder-car.png';
                      }}
                    />
                  ) : (
                    <div className="no-image-placeholder">
                      <span>🚗</span>
                      <p>No Image</p>
                    </div>
                  )}
                  <div className="image-gradient"></div>
                </div>

                <div className="model-card-content">
                  <h3 className="model-name">
                    {car.brand} {car.model}
                  </h3>
                  
                  <div className="variant-info">
                    <span className="variant-text">
                      {car.year} • {car.fuel_type || 'Petrol'}
                    </span>
                  </div>

                  <p className="variant-text">
                    {car.km_driven ? `${car.km_driven} km` : 'N/A'} • 
                    {car.transmission || 'Manual'} • 
                    {car.variant || 'Standard'}
                  </p>

                  <p className="variant-location">📍 {car.location || 'India'}</p>
                  
                  <p className="variant-price">
                    ₹{parseFloat(car.price).toLocaleString('en-IN')}
                  </p>

                  <div className="explore-btn">
                    <span>View Details</span>
                    <span className="arrow-icon">→</span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BrandPage;